import { QuoteType } from '../../../enums/quoteType'

export const quotesTypeToTitleKey: Record<QuoteType, string> = {
  [QuoteType.Estimate]: 'legacyQuotes.type.estimate',
  [QuoteType.OrderConfirmation]: 'legacyQuotes.type.order_confirmation',
  [QuoteType.Quote]: 'quote',
}
